import React from 'react';
import { PqrWebService } from '../../services/services';
import { IHomeComponentProps } from './home.props';
import { IHomeComponentState } from './home.state';
import { MsalAuthProvider, LoginType } from "react-aad-msal";
import { Sede } from '../../classes/shared';
import MainButton from './MainButton';

const rowStyle: React.CSSProperties = {
  marginTop: '15px',
  textAlign: 'center',
  paddingTop: '15px'
}

export class HomeComponent extends React.Component<IHomeComponentProps, IHomeComponentState> {

  private _pqrWebService: PqrWebService;
  private _authProvider: MsalAuthProvider;

  constructor(props: any) {
    super(props);
    this.state = {
      showEntidadesAdscritas: false,
      showVerificarDocumentos: false,
      showSolicitudesAnonimas: true
    }

    this._pqrWebService = new PqrWebService();

    this._authProvider = new MsalAuthProvider(
      {
        auth: {
          authority: Sede.Shared.Context.B2C.Authority,
          clientId: Sede.Shared.Context.B2C.ClientId,
          postLogoutRedirectUri: window.location.origin + '/sede.html',
          redirectUri: window.location.origin + '/sede.html',
          validateAuthority: false,
        },
        cache: {
          cacheLocation: "localStorage",
          storeAuthStateInCookie: true
        }
      },
      {
        scopes: [ Sede.Shared.Context.B2C.Scopes ]
      },
      {
        loginType: LoginType.Popup,
        tokenRefreshUri: window.location.origin
      }
    );
  }

  public async componentDidMount(): Promise<void> {
    try {

      sessionStorage[ 'forceLogin' ] = false;
      const showEntidadesAdscritas = Sede.Shared.Context.IsAffiliatedEntitiesEnabled;
      const showVerificarDocumentos = Sede.Shared.Context.IsDocumentVerificationEnabled;
      const showSolicitudesAnonimas = Sede.Shared.Context.IsAnonymousRequestsEnabled;

      // Obtener los trámites que se deben mostrar en un botón
      const buttons = Sede.Shared.Context.Tramites.map(x => x.Props?.ShowButtonInWeb);


      if (showEntidadesAdscritas || showVerificarDocumentos || !showSolicitudesAnonimas) {
        this.setState({
          showEntidadesAdscritas: showEntidadesAdscritas,
          showVerificarDocumentos: showVerificarDocumentos,
          showSolicitudesAnonimas: showSolicitudesAnonimas
        })
      }

      const search = window.location.hash.split('?');
      const queryParams = new URLSearchParams(search[ 1 ]);

      if (queryParams !== undefined) {
        const auth = queryParams.get('auth');

        if (auth == "b2c") {
          sessionStorage[ 'forceLogin' ] = true;
          sessionStorage[ 'b2c' ] = true;
          this.setState({
            showSolicitudesAnonimas: false
          })
        }
      }

    } catch (err) {
      if (err instanceof Error) {
        alert(err.message);
      }
    }
  }

  render(): JSX.Element {

    const showAnonymous = (this.isAuthenticate && this.state.showSolicitudesAnonimas) || !this.isAuthenticate;
    const tramites = Sede.Shared.Context?.Tramites || [];
    const customButtons = tramites.filter(x => x.Props?.ShowButtonInWeb) || [];

    return <div className='ms-Grid'>
      <div className='ms-Grid-row'>
        <div className='ms-Grid-col ms-12' style={{ marginTop: '15px' }}>
          <h1 className='ms-font-xl ms-fontWeight-semibold'>Gestión PQRSD</h1>
        </div>
      </div>
      {
        this.isAuthenticate === true && <div className='ms-Grid-row'>
          <div className='ms-Grid-col ms-u-sm12' style={{ marginTop: '15px', textAlign: 'center' }}>
            Bienvenido {sessionStorage.getItem('ioip.pqr-web.session.nombres')} {sessionStorage.getItem('ioip.pqr-web.session.apellidos')}
          </div>
        </div>
      }

      <div className='ms-Grid-row card-grid' style={rowStyle}>
        <MainButton
          title="Formular solicitud"
          description="Aquí podrá registrar sus peticiones ciudadanas para que sean atendidas"
          url="#/sign-in/create-pqr"
          icon='PageAdd'
        />
        {
          showAnonymous && <MainButton
            title="Formular solicitud anónima"
            description="Podrá realizar su solicitud de forma anónima para su atención"
            url="#/create-pqr/anonymous"
            icon='TextDocument'
          />
        }
        {customButtons.map(x => <>
          <MainButton
            key={`tramite-${x.IdTramite}`}
            title={x.Nombre}
            description={x.Descripcion}
            url={`#/sign-in/create-pqr?tramiteId=${x.IdTramite}`}
            icon='TextDocument'
          />
          <MainButton
            key={`tramite-${x.IdTramite}-anonymous`}
            title={x.Nombre + ' Anonimo'}
            description={x.Descripcion}
            url={`#/create-pqr/anonymous?tramiteId=${x.IdTramite}`}
            icon='TextDocument'
          />
        </>)}
        <MainButton
          title="Consultar solicitudes"
          description="Aquí podrá consultar las peticiones que ya registró en el sistema"
          url="#/sign-in/my/requests"
          icon='DocumentSearch'
        />
        {
          showAnonymous && <MainButton
            title="Consultar solicitud anónima"
            description="Verifique el estado actual de su solicitud anónima"
            url="#/check-anonymous-request"
            icon='SearchIssue'
          />
        }
        {
          this.state.showEntidadesAdscritas && <MainButton
            title="Entidades adscritas"
            description="Ingrese aquí si hace parte de alguna entidad adscrita al Ministerio de Defensa Nacional"
            url="#/sign-in/answer-rs"
            icon='PartyLeader'
          />
        }
        {
          this.state.showVerificarDocumentos && <MainButton
            title="Validar documentos"
            description="Permite verificar la autenticidad de los documentos firmados electrónicamente por el Ministerio de Defensa Nacional"
            url="#/verify-document"
            icon='PageCheckedin'
          />
        }
        {
          this.isAuthenticate && <>
            <MainButton
              title="Actualizar información"
              description="Actualice su información de contacto para estar al tanto de sus solicitudes"
              url="#/edit-contact"
              icon='UserSync'
            />
            <MainButton
              title="Cerrar sesión"
              description="Cierre sesión de forma segura en nuestro sistema"
              onClick={() => this._closeSession()}
              icon='SignOut'
            />
          </>
        }
      </div>

    </div>
  }

  private _closeSession(): void {
    sessionStorage.clear();
    this.setState({});

    this._authProvider.logout();
  }

  private get isAuthenticate(): boolean {
    const token = sessionStorage.getItem('ioip.pqr-web.session.token');
    if (token === null || token === undefined) {
      return false;
    }
    const date = sessionStorage.getItem('ioip.pqr-web.session.expiracion');
    return true;
  }

}